import { useState } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function AddUserModal({ grupos, closeModal, onDataAdded }) {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedGroupId) { setError('Por favor, selecione um grupo.'); return; }
    setLoading(true);
    setError(null);

    try {
      const { data: { session: adminSession } } = await supabase.auth.getSession();
      if (!adminSession) throw new Error("Sessão de administrador não encontrada. Faça login novamente.");

      const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
        email: email,
        password: password,
        options: {
          data: {
            nome_completo: nome,
            status: 'ativo',
            grupo_id: parseInt(selectedGroupId, 10)
          }
        }
      });
      if (signUpError) throw signUpError;
      const newUserId = signUpData.user?.id;
      if (!newUserId) throw new Error('Usuário criado, mas ID não retornado.');

      await supabase.auth.setSession({
        access_token: adminSession.access_token,
        refresh_token: adminSession.refresh_token
      });
      
      onDataAdded();
      closeModal();

    } catch (err) {
      setError(`Erro no processo de criação: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Adicionar Novo Usuário</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome Completo</label>
            <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Email (para login do usuário)</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Senha Inicial</label>
            <input type="password" placeholder="Mínimo 6 caracteres" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Associar ao Grupo</label>
            <select value={selectedGroupId} onChange={(e) => setSelectedGroupId(e.target.value)} required>
                <option value="" disabled>Selecione um grupo</option>
                {grupos.map(grupo => (
                    <option key={grupo.id} value={grupo.id}>
                        {grupo.nome_grupo}
                    </option>
                ))}
            </select>
          </div>

          {error && <p className="error-message">{error}</p>}

          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Usuário'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddUserModal;